import queryString from 'query-string';


const DOCUMENT_ID_QUERY_PARAM_KEY = 'documentID';

/**
 * Parse the document id queryString from URL
 * @returns {string} document id queryString
 */
function getDocumentIdFromWindowLocation() {
    return queryString.parse(window.location.search)[DOCUMENT_ID_QUERY_PARAM_KEY];
}

export default getDocumentIdFromWindowLocation;
export { DOCUMENT_ID_QUERY_PARAM_KEY };
